import { render } from "./ContractDistributionDetails.vue?vue&type=template&id=81082f58"
import script from "./ContractDistributionDetails.vue?vue&type=script&lang=js"
export * from "./ContractDistributionDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__